export default {
	data() {
		return {
			levelType: 0,
			preUrl: "",
			delAllUrl: "",
			delUrl: "",
			addUrl: "",
			editStatusUrl: "",
			showScrollbar: false,
			page: {
				current: 1,
				sizes: [10, 20, 50, 100],
				size: 10,
				total: 0
			},
			search: '',
			toid:0,
			prop: 'create_time',
			sort: 'descending',
			isUpdateNum: false,
			
			multipleSelection: [],
			pickerOptions: {
				shortcuts: [{
					text: '最近一周',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近一个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近三个月',
					onClick(picker) {
						const end = new Date();
						const start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	filters: {
		numToString(value) {
			return value.toString();
		}
	},
	created() {
		console.log(this.$route.params)
		if (typeof this.$route.params.toid != 'undefined') {
			this.toid = this.$route.params.toid
		}
		if (typeof this.$route.params.search != 'undefined') {
			this.search = this.$route.params.search
		}
		
		this.getList()
	},
	mounted() {
	  this.updateThumbPosition();
	      this.$refs.table.$el.querySelector('.el-table__body-wrapper').addEventListener('scroll', this.updateThumbPosition);
	      document.addEventListener('mousemove', this.onMouseMove);
	      document.addEventListener('mouseup', this.onMouseUp);
	      this.initializeScrollbar();
	},
	beforeDestroy() {
	    this.$refs.table.$el.querySelector('.el-table__body-wrapper').removeEventListener('scroll', this.updateThumbPosition);
	    document.removeEventListener('mousemove', this.onMouseMove);
	    document.removeEventListener('mouseup', this.onMouseUp);
	},
	
	computed: {
		// 选中记录id组成的数组
		ids() {
			return this.multipleSelection.map(item => {
				return item.id
			})
		},
		scrollbarWidth() {
		  return `calc(100% - ${this.layout.scrollXWidth}px)`;
		}
	},
	methods: {
		initializeScrollbar() {
		       this.$nextTick(() => {
		           this.updateThumbPosition();
		       });
		   },
		   updateThumbPosition() {
		       const tableBodyWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
		       const scrollbar = this.$refs.scrollbar;
		       const thumb = this.$refs.thumb;
		       const scrollPercent = tableBodyWrapper.scrollLeft / (tableBodyWrapper.scrollWidth - tableBodyWrapper.clientWidth);
		       const thumbWidth = scrollbar.clientWidth * (tableBodyWrapper.clientWidth / tableBodyWrapper.scrollWidth);
		       thumb.style.width = `${thumbWidth}px`;
		       thumb.style.left = `${scrollPercent * (scrollbar.clientWidth - thumbWidth)}px`;
				
		       // 检查是否需要显示滚动条
		       this.showScrollbar = tableBodyWrapper.scrollWidth > tableBodyWrapper.clientWidth;
		   },
		   onMouseDown(e) {
		       this.isDragging = true;
		       this.startX = e.clientX - this.$refs.thumb.offsetLeft;
		       document.body.style.userSelect = 'none';
		   },
		   onMouseMove(e) {
		       if (!this.isDragging) return;
		       const tableBodyWrapper = this.$refs.table.$el.querySelector('.el-table__body-wrapper');
		       const scrollbar = this.$refs.scrollbar;
		       const thumb = this.$refs.thumb;
		       const newLeft = e.clientX - this.startX;
		       const maxLeft = scrollbar.clientWidth - thumb.clientWidth;
		       const boundedLeft = Math.max(0, Math.min(newLeft, maxLeft));
		       thumb.style.left = `${boundedLeft}px`;
		       const scrollPercent = boundedLeft / maxLeft;
		       tableBodyWrapper.scrollLeft = scrollPercent * (tableBodyWrapper.scrollWidth - tableBodyWrapper.clientWidth);
		   },
		   onMouseUp() {
		       this.isDragging = false;
		       document.body.style.userSelect = '';
		   },
		   fetchData() {
		       this.axios.get('/your-api-endpoint').then(response => {
		           this.tableData = response.data;
		           this.$nextTick(() => {
		               this.updateThumbPosition();
		           });
		       });
		   },
		   changeDynamicWidth(newWidth) {
		       this.dynamicWidth = newWidth;
		       this.updateThumbPosition();
		   },
		
		// 搜索
		searchEvent(e = false) {
			// 简单搜索
			if (typeof e === 'string') {
				this.search = e;
				this.getList()
				return
				//return console.log('简单搜索')
			}
			this.search = this.from
			this.getList()
			//console.log(this.from);
			// 高级搜索
			//console.log('高级搜索')
		},
		// 多选
		handleSelectionChange(val) {
			this.multipleSelection = val;
			console.log(this.multipleSelection);
		},
		handleSizeChange(val) {
			this.page.size = val
			//console.log(`每页 ${val} 条`);
			this.getList()
		},
		sortChange(column){
			this.prop = column.prop
			this.sort = column.order
			this.getList()
		},
		handleCurrentChange(val) {
			this.page.current = val
			this.getList()
			//console.log(`当前页: ${val}`);
		},
		// 处理列表结果
		getListResult(data) {

		},

		// 获取请求列表分页url
		getListUrl() {
			return `/admin/${this.preUrl}`
		},
		handleClick(tab, event) {
			this.search = ''
			this.getList()
		},

		//获取列表
		getList() {
			if (this.preUrl == '') return
			this.layout.loading = true;
			this.axios.post(this.getListUrl(), {
				page: this.page.current,
				limit: this.page.size,
				search: this.search,
				prop: this.prop,
				type: this.type,
				toid:this.toid,
				sort: this.sort == 'ascending' ? 'asc' : 'desc'
			}, {
				token: true,
				loading: true
			}).then(res => {
				let all = res.data
				let list = all.data.list

				this.page.total = list.total
				this.toid = 0
				//this.tableData = list.list
				this.getListResult(list)
				

				this.layout.loading = false;
				this.initializeScrollbar();
			}).catch(err => {
				// 失败
				console.log(err);
				this.layout.loading = false;
			})
		},
		// 添加/修改url
		changeStatusUrl() {
			return `/admin/${this.editStatusUrl}`
		},
		// 修改状态
		changeStatus(item, type = 1) {
			//1:status,2:is_show
			let status = 0;
			if (type == 2) {
				status = item.is_show === 1 ? 0 : 1
			} else if (type == 3) {
				status = item.is_login === 1 ? 0 : 1
			} else if (type == 4) {
				status = item.is_home === 1 ? 0 : 1
			} else if (type == 5) {
				status = item.is_service === 1 ? 0 : 1
			} else if (type == 6) {
				status = item.is_home_bottom === 1 ? 0 : 1
			} else if (type == 7) {
				status = item.is_top === 1 ? 0 : 1
			} else {
				status = item.status === 1 ? 0 : 1
			}


			let msg = status === 1 ? '启用' : '禁用'
			this.layout.loading = false;
			this.axios.post(this.changeStatusUrl(), {
				id: item.id,
				status: status,
				type: type,
				page_type: this.type
			}, {
				token: true
			}).then(res => {


				let all = res.data
				if (all.code == 1) {
					if (type == 2) {
						item.is_show = status
					} else if (type == 3) {
						item.is_login = status
					} else if (type == 4) {
						item.is_home = status
					} else if (type == 5) {
						this.getList()
						item.is_service = status
					} else if (type == 6) {
						item.is_home_bottom = status
					} else if (type == 7) {
						item.is_top = status
					} else {
						item.status = status
					}
					this.$message({
						message: msg + '成功',
						type: 'success'
					});

				}
				this.createModel = false
			}).catch(err => {
				this.createModel = false
			})
		},
		// 添加/修改url
		addOrEditUrl() {
			return `/admin/${this.addUrl}`
		},
		showExpress(data){
			this.layout.showExpressModel(data);
		},
		//添加/修改
		addOrEdit(data,is_update = false) {
			this.layout.loading = true;
			this.axios.post(this.addOrEditUrl(), data, {
				token: true
			}).then(res => {
				let all = res.data
				if (all.code == 1) {
					this.$message({
						message: all.msg,
						type: 'success'
					});
					// if (this.isUpdateNum) {
					// 	this.layout.getPageNum()
					// }
					this.createModel = false
					if(is_update){
						this.layout.getPageNum()
					}
				}
				this.getList()
				this.layout.loading = false;
			}).catch(err => {
				this.layout.loading = false;
			})
		},
		
		//复制对象
		deepClone(obj) {
		    if (obj === null || typeof obj !== 'object') {
		        return obj;
		    }
		
		    // 创建一个新的对象或数组，根据原始对象的类型
		    const newObj = Array.isArray(obj) ? [] : {};
		
		    // 递归地复制原始对象的属性到新对象中
		    for (let key in obj) {
		        if (obj.hasOwnProperty(key)) {
		            newObj[key] = this.deepClone(obj[key]);
		        }
		    }
		
		    return newObj;
		},

		// 批量删除url
		deleteAllUrl() {
			return `/admin/${this.delAllUrl}`
		},
		
		// 批量删除
		deleteAll() {
			if (this.ids.length === 0) {
				return this.$message({
					message: '请先选中需要删除的数据',
					type: 'error'
				});
			}
			this.$confirm('是否要删除选中数据?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.layout.loading = true;
				let url = this.deleteAllUrl()
				this.axios.post(url, {
					ids: this.ids,
					type: this.type
				}, {
					token: true,
					loading: true
				}).then(res => {

					this.multipleSelection = []
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					console.log(1);
					this.getList()

					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			})
		},
		// 删除url
		deleteUrl() {
			return `/admin/${this.delUrl}`
		},
		// 删除单个
		deleteItem(item) {
			this.$confirm('是否要删除该数据?', '提示', {
				confirmButtonText: '删除',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.layout.loading = true;
				this.axios.post(this.deleteUrl(), {
					id: item.id,
					type: this.type
				}, {
					token: true
				}).then(res => {
					this.$message({
						message: '删除成功',
						type: 'success'
					});
					this.getList()
					this.layout.loading = false;
				}).catch(err => {
					this.layout.loading = false;
				})
			})
		},
	}
}
